import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import './styles/site.css';
import { FournisseurLangue, useLangue } from './i18n/LangueContext';
import Entete from './components/Entete';
import Pied from './components/Pied';
import Accueil from './pages/Accueil';
import { PageDemande, PageLegale } from './pages/Pages';

const HautDePage = () => {
  const { pathname, state } = useLocation();
  useEffect(() => {
    if (!(state && state.ancre)) window.scrollTo(0, 0);
  }, [pathname, state]);
  return null;
};

const Saut = () => {
  const { t } = useLangue();
  return <a className="saut" href="#principal">{t.saut}</a>;
};

const Site = () => (
  <BrowserRouter>
    <HautDePage />
    <Saut />
    <Entete />
    <Routes>
      <Route path="/" element={<Accueil />} />
      <Route path="/demander-un-acces" element={<PageDemande cle="pageAcces" type="acces" />} />
      <Route path="/devenir-partenaire" element={<PageDemande cle="pagePartenaire" type="partenaire" />} />
      <Route path="/contact" element={<PageDemande cle="pageContact" type="contact" />} />
      <Route path="/mentions-legales" element={<PageLegale cle="mentions" />} />
      <Route path="/politique-de-confidentialite" element={<PageLegale cle="confidentialite" />} />
      <Route path="/politique-des-cookies" element={<PageLegale cle="cookies" />} />
      <Route path="/conditions-generales" element={<PageLegale cle="conditions" />} />
      <Route path="*" element={<Accueil />} />
    </Routes>
    <Pied />
  </BrowserRouter>
);

const App = () => (
  <FournisseurLangue>
    <Site />
  </FournisseurLangue>
);

export default App;
